export enum PaymentStepResultKeys {
	WasSuccessful = 'wasSuccessful',
	ClientPaymentValidationSuccessful = 'clientPaymentValidationSuccessful',
	UseCardOnFile = 'useCardOnFile',
	UsingApplePay = 'usingApplePay'
}
